// Countdown Timer function
function countdown(targetDate) {
  const now = new Date().getTime();
  const timeLeft = new Date(targetDate).getTime() - now;

  if (timeLeft > 0) {
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    return { days, hours, minutes, seconds };
  } else {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
}

// Allow dynamic expiry date
export function getCountdown(expiryDate) {
  if (!expiryDate) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return countdown(expiryDate);
}
